import React, { useState } from 'react';
import { X } from 'lucide-react';

export const SizeGuide = () => {
    const [open, setOpen] = useState(false);

    const sizes = [
        { size: 'S', chest: '36-38', length: '27', shoulder: '17' },
        { size: 'M', chest: '38-40', length: '28', shoulder: '18' },
        { size: 'L', chest: '40-42', length: '29', shoulder: '19' },
        { size: 'XL', chest: '42-44', length: '30', shoulder: '20' },
        { size: 'XXL', chest: '44-46', length: '31', shoulder: '21' },
    ];

    return (
        <>
            <button onClick={() => setOpen(true)}
                className="text-xs text-muted-foreground hover:text-lime underline transition-colors">
                Size Guide
            </button>

            {open && (
                <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
                    <div className="absolute inset-0 bg-black/80" onClick={() => setOpen(false)} />
                    <div className="relative bg-card border border-border w-full max-w-md p-6 z-10">
                        <button onClick={() => setOpen(false)}
                            className="absolute top-4 right-4 p-1 hover:text-lime transition-colors">
                            <X className="w-5 h-5" />
                        </button>
                        <h3 className="font-heading text-xl mb-2">SIZE GUIDE</h3>
                        <p className="text-xs text-muted-foreground mb-4">All measurements in inches. Our fits are oversized.</p>
                        <table className="w-full text-sm">
                            <thead>
                                <tr className="border-b border-border">
                                    <th className="text-left py-2 text-xs uppercase tracking-wider text-lime">Size</th>
                                    <th className="text-left py-2 text-xs uppercase tracking-wider">Chest</th>
                                    <th className="text-left py-2 text-xs uppercase tracking-wider">Length</th>
                                    <th className="text-left py-2 text-xs uppercase tracking-wider">Shoulder</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sizes.map((row) => (
                                    <tr key={row.size} className="border-b border-border/50 hover:bg-background/50">
                                        <td className="py-2 font-bold text-lime">{row.size}</td>
                                        <td className="py-2 text-muted-foreground">{row.chest}"</td>
                                        <td className="py-2 text-muted-foreground">{row.length}"</td>
                                        <td className="py-2 text-muted-foreground">{row.shoulder}"</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <p className="text-xs text-muted-foreground mt-4">
                            💡 Tip: If you're between sizes, size up for a more relaxed streetwear fit.
                        </p>
                    </div>
                </div>
            )}
        </>
    );
};
